<template>
	<v-dialog v-model="dialog_open" persistent light overlay-opacity="0.95" width="900" @input="$emit('dialog_done')">
		<v-card light>
			<v-card-title class="text-left align-start" style="font-size:22px!important; line-height:28px;">
				<img src="./../../images/google_classroom_logo.png" style="height:48px;border-radius:2px;margin-right:12px;margin-top:4px">
				<div>
					<b>Create Assignment in Google Classroom:</b><br>
					<span v-html="activity_title" class="ml-0"></span>
				</div>
			</v-card-title>
			<v-card-text style="color:#000;">
				<div class="mt-5 d-flex">
					<div class="mr-3 mt-1" style="width:180px"><b>Courses to assign to:</b></div>
					<div style="width:600px;">
						<v-select light dense outlined hide-details append-icon="fas fa-caret-down"
							v-model="gc_courses_for_assignment" 
							:items="available_courses" 
							multiple
							label="Course(s)" 
						></v-select>
					</div>
				</div>

				<div class="mt-5 d-flex">
					<div class="mr-3 mt-1" style="width:180px; line-height:18px;"><b>Instructions to students:</b><br>(optional)</div>
					<div style="width:600px;">
						<v-textarea outlined dense hide-details clearable auto-grow label="" placeholder="" rows="3"
							v-model="assignment_description"
						></v-textarea>
					</div>
				</div>

				<div class="mt-5 d-flex align-center">
					<div class="mr-3">
						<k-checkbox class="mt-0 pt-0" hide-details off-icon="far fa-square" on-icon="fas fa-check-square"
							v-model="graded_assignment"
						><template v-slot:label><div style="color:#000">Graded Assignment</div></template></k-checkbox>
					</div>

					<div class="ml-6" style="width:100px"
						v-if="graded_assignment"
					>
						<v-text-field outlined hide-details dense
							v-model="max_points"
							label="Max Points"
						></v-text-field>
					</div>

					<div class="ml-5" style="line-height:20px"
						v-if="graded_assignment"
					>
						<i>{{site_config.sparkl_app_name}} grades will be automatically sent back to Google Classroom.</i>
					</div>
				</div>

				<div class="mt-5 d-flex align-center">
					<div class="mr-3">
						<k-checkbox class="mt-0 pt-0" hide-details off-icon="far fa-square" on-icon="fas fa-check-square"
							v-model="publish_immediately"
						><template v-slot:label><div style="color:#000">Publish immediately</div></template></k-checkbox>
					</div>

					<div class="ml-6 mr-3 mt-1" style="line-height:18px;"
						v-show="!publish_immediately"
					><b>Scheduled date:</b><br>(optional)</div>

					<div style="width:180px"
						v-show="!publish_immediately"
					>
						<v-menu ref="scheduled_date_menu" v-model="scheduled_date_menu" :close-on-content-click="false" :return-value.sync="scheduled_date" transition="scale-transition" offset-y min-width="290px">
							<template v-slot:activator="{on}"><v-text-field background-color="#fff" outlined dense hide-details v-model="scheduled_date_formatted" label="Scheduled Date" append-icon="fas fa-calendar-day" @click:append="scheduled_date_menu=true" readonly v-on="on"></v-text-field></template>
							<v-date-picker v-model="scheduled_date" no-title scrollable>
								<v-btn text color="primary" @click="no_scheduled_date">Clear Date</v-btn>
								<v-spacer></v-spacer>
								<v-btn text color="primary" @click="scheduled_date_menu=false">Done</v-btn>
							</v-date-picker>
						</v-menu>
					</div>
					<div class="mr-3 mt-1 ml-6" style="line-height:18px;"><b>Due date:</b><br>(optional)</div>
					<div style="width:180px">
						<v-menu ref="due_date_menu" v-model="due_date_menu" :close-on-content-click="false" :return-value.sync="due_date" transition="scale-transition" offset-y min-width="290px">
							<template v-slot:activator="{on}"><v-text-field background-color="#fff" outlined dense hide-details v-model="due_date_formatted" label="Due Date" append-icon="fas fa-calendar-day" @click:append="due_date_menu=true" readonly v-on="on"></v-text-field></template>
							<v-date-picker v-model="due_date" no-title scrollable>
								<v-btn text color="primary" @click="no_due_date">Clear Date</v-btn>
								<v-spacer></v-spacer>
								<v-btn text color="primary" @click="due_date_menu=false">Done</v-btn>
							</v-date-picker>
						</v-menu>
					</div>
				</div>

				<div class="mt-5 d-flex align-center" style="line-height:20px">
					<i>If you “Publish immediately”, the Assignment will be automatically “Assigned” to students, so they can access it right away. If you uncheck this box, you must set a Scheduled date, or click the “Assign” button in Google Classroom, for your students to be able to access it.</i>
				</div>

			</v-card-text>
			<v-card-actions class="pt-2">
				<v-btn color="secondary" @click="$emit('dialog_done')"><v-icon small class="mr-2">fas fa-xmark</v-icon>Cancel</v-btn>
				<v-spacer/>
				<v-btn color="primary" class="k-tight-btn" @click="submit_to_gc">Create Google Classroom Assignment<v-icon small class="ml-2">fas fa-arrow-right</v-icon></v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
// import DialogComponent from '@/components/DialogComponent'

export default {
// components: { DialogComponent },
	props: {
		activity_id: { required: true },
		activity_title: { required: true },
	},
	data() { return {
		dialog_open: true,

		scheduled_date: '',
		scheduled_date_menu: false,
		due_date: '',
		due_date_menu: false,
	}},
	computed: {
		...mapState(['user_info', 'gc_courses', 'site_config']),
		...mapGetters([]),

		// save these settings in lst since the teacher may want to use them across many assignments
		gc_courses_for_assignment: {
			get() { 
				// we have to filter this based on actual gc_courses, in case the teacher's courses have changed
				let arr = []
				for (let course_id of this.$store.state.lst.gc_courses_for_assignment) {
					if (this.gc_courses.find(x=>x.id == course_id)) {
						arr.push(course_id)
					}
				}
				return arr 
			},
			set(val) { this.$store.commit('lst_set', ['gc_courses_for_assignment', val]) }
		},
		assignment_description: {
			get() { return this.$store.state.lst.gc_description_for_assignment },
			set(val) { this.$store.commit('lst_set', ['gc_description_for_assignment', val]) }
		},
		publish_immediately: {
			get() { return this.$store.state.lst.gc_publish_immediately_for_assignment },
			set(val) { this.$store.commit('lst_set', ['gc_publish_immediately_for_assignment', val]) }
		},
		max_points: {
			get() { return this.$store.state.lst.gc_max_points_for_assignment },
			set(val) { this.$store.commit('lst_set', ['gc_max_points_for_assignment', val]) }
		},

		graded_assignment: {
			get() { return this.max_points > 0 },
			set(val) {
				if (val) this.max_points = 100
				else this.max_points = 0
			}
		},

		scheduled_date_formatted() {
			if (empty(this.scheduled_date)) return ''
			let d = new Date(this.scheduled_date + 'T00:00:00')
			return date.format(d, 'ddd MMM D')	// Tue Jan 9
		},

		due_date_formatted() {
			if (empty(this.due_date)) return ''
			let d = new Date(this.due_date + 'T00:00:00')
			return date.format(d, 'ddd MMM D')	// Tue Jan 9
		},

		available_courses() {
			let arr = []
			for (let course of this.gc_courses) {
				let o = {
					value: course.id,
					text: course.name,
				}
				arr.push(o)
			}
			console.warn(arr)
			return arr
		},
	},
	watch: {
		scheduled_date(val) {
			if (this.$refs.scheduled_date_menu) this.$refs.scheduled_date_menu.save(this.scheduled_date)
		},
		due_date(val) {
			if (this.$refs.due_date_menu) this.$refs.due_date_menu.save(this.due_date)
		},
	},
	created() {
		vapp.add_to_google_classroom_component = this
	},
	mounted() {
	},
	methods: {
		no_scheduled_date() {
			// if you clear the starting lesson date, you can't have an ending lesson date
			this.scheduled_date = ''
			this.scheduled_date_menu = false
		},
		no_due_date() {
			// if you clear the starting lesson date, you can't have an ending lesson date
			this.due_date = ''
			this.due_date_menu = false
		},

		async submit_to_gc() {
			// note that we should only be here if we've successfully called gc_get_courses, which means that the user has authenticated with the right scopes

			// at least one course must be selected
			if (this.gc_courses_for_assignment.length == 0) {
				this.$alert('Please choose at least one course to assign to.')
				return
			}

			// if publish_immediately is true, scheduled_date must be empty
			if (this.publish_immediately) {
				this.scheduled_date = ''
			}

			// you can't set a due date in the past
			if (new Date(this.due_date) <= new Date()) {
				this.$alert('You must choose a Due date in the future.')
				return
			}

			let payload = {
				user_id: this.user_info.user_id,
				teacher_email: this.user_info.email,
				activity_id: this.activity_id,
				activity_title: this.activity_title,
				gc_courses: this.gc_courses_for_assignment,
				app_noun: this.site_config.app_name,
				assignment_description: this.assignment_description,
				max_points: this.max_points,
				publish_immediately: this.publish_immediately,
				scheduled_date: this.scheduled_date,
				due_date: this.due_date,
			}
			console.warn(payload)

			U.loading_start()
			let ajax_result = await U.ajax_promise('gc_assign_to_courses', payload)
			// let ajax_result = {status:'ok', successful_assignments: [
			// 	{
			// 		"courseId": "824027830048",
			// 		"courseWorkId": "860518672419",
			// 		"attachmentId": "860516533282"
			// 	}
			// ]}
			U.loading_stop()
			console.warn(ajax_result)
			if (ajax_result.status != 'ok') {
				// handle error
				let msg
				if (ajax_result.status == 'user_ineligible_to_create_addon_attachment') {
					msg = `The ${this.site_config.sparkl_app_name} attachment could not be created because your Google account does not currently have permission to use Google Classroom Add-ons. This is usually managed by your district’s IT department.`
						+ `<div class="mt-3"><b>Tip for contacting IT:</b> Check with your IT team to see if Google Classroom Add-on permissions are available for your account tier and enabled for your organizational unit, and <b>take a screenshot of the following information</b> when reporting the error:</div>`
						+ `<div class="mt-3"><b>User:</b> ${this.user_info.email}</div>`
						+ `<div class="mt-2"><b>Time:</b> ${new Date().toString()}</div>`
						+ `<div class="mt-2"><b>Error info:</b> @UserIneligibleToCreateAddOnAttachment</div>`
				} else {
					msg = `An error occurred: <b class="red--text text--darken-3">${ajax_result.status}</b>. Please take a screenshot of the following information when reporting the error:`
						+ `<div class="mt-3"><b>User:</b> ${this.user_info.email}</div>`
						+ `<div class="mt-2"><b>Time:</b> ${new Date().toString()}</div>`
						+ `<div class="mt-2"><b>Error info:</b> ${JSON.stringify(ajax_result.error_details)}</div>`
				}
				this.$alert({
					title: 'Sorry, but an error occurred.',
					text: msg,
					dialogMaxWidth: 620,
				})
				return
			}

			let assignments = ajax_result.successful_assignments
			let ps = (assignments.length > 1) ? 's' : ''
			let title = `Assignment${ps} created!`
			let msg = ''
			if (!this.publish_immediately && empty(this.scheduled_date)) {
				msg += '<b>PLEASE NOTE:</b> Your students will not be able to access your Assignment until you “Assign” it from Google Classroom.'
			}
			msg += `<div class="mt-3">Click the link${ps} below to open your course${ps} in a new window.</div>`
			msg += '<ul class="mt-1">'
			for (let a of assignments) {
				let course = this.gc_courses.find(x=>x.id == a.courseId)
				// translate url from/to:
				// https://classroom.google.com/c/ODI0MDI3ODMwMDQ4
				// https://classroom.google.com/w/ODI0MDI3ODMwMDQ4/t/all
				let url = course.alternateLink.replace(/(google.com)\/c\/(.*)/, '$1/w/$2/t/all')
				msg += `<li class="mt-2"><a href="${url}" target="_blank">Course: ${course.name}</a></li>`
			}
			msg += '</ul>'

			this.$alert({
				title: title,
				text: msg
			})

			// close the add to gc dialog while the user sees the alert
			this.$emit('dialog_done')
		},
	}
}
</script>

<style lang="scss">
</style>